import { BgColor, PerfilApi, Template } from '@conacyt/perfil-usuario-client';
import SolicitudService from '@/entities/solicitud/solicitud.service';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Reconsideracion, Solicitud } from '@/shared/model/solicitud.model';
import JhiDataUtils from '@/shared/data/data-utils.service';
import AlertService from '@/shared/alert/alert.service';
import { DmsApi, EtapaEnum, Archivo } from '@conacyt/dms-client';
import { Solucion } from '@/shared/model/solucion.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import * as dateUtils from '@/shared/date/date-utils';

@Component
export default class DocumentosSniiComponent extends mixins(JhiDataUtils) {
  @Inject('perfilApi') public perfilApi: () => PerfilApi;
  @Inject('solicitudService') private solicitudService: () => SolicitudService;
  @Inject('alertService') private readonly alertService: () => AlertService;
  @Inject('dmsApi') public dmsApi: () => DmsApi;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public solucion: Solucion;

  public reconsideracion: Reconsideracion = {};

  private readonly ETAPA: EtapaEnum = 'REGISTRO';

  private CARPETA = 'DADC';

  mounted() {
    this.reconsideracion = this.solicitud?.reconsideracion ?? {};
  }

  get userInfo() {
    return this.$store.getters.userInfo;
  }

  public guardarReconsideracion(): void {
    this.reconsideracion.fechaEnvio = new Date();
    this.solicitud.reconsideracion = this.reconsideracion;

    this.solicitudService()
      .partialUpdate(this.solicitud)
      .then(() => this.alertService().showSuccess(this, this.$t('Se ha guardado satisfactoriamente la información', 'Exitoso').toString()))
      .catch(() => this.alertService().showError(this, 'Error al guardar la información'));
  }

  public guardarDocumentoPerfil(): void {}

  /**
   * Consulta la Perfil único actualizado
   */
  public async consultaPerfilRizoma(): Promise<void> {
    try {
      this.onProcess = true;
      const res = await this.perfilApi().getReportePerfil(Template.COMPLETO_SIN_FOTO, BgColor.VINO);

      const now = new Date();
      const mexicoDate = new Date(now.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));

      const fechaEnvio =
        mexicoDate.getFullYear().toString() +
        String(mexicoDate.getMonth() + 1).padStart(2, '0') +
        String(mexicoDate.getDate()).padStart(2, '0') +
        String(mexicoDate.getHours()).padStart(2, '0') +
        String(mexicoDate.getMinutes()).padStart(2, '0');

      const archivo: Archivo = {
        nombre: `PU-${this.userInfo.cvu}_${fechaEnvio}-Recons.pdf`,
        contenido: res.data.contenidoBase64,
      };

      const uploadResponse = await this.dmsApi().agregaDocumento(
        this.CARPETA,
        this.solicitud?.id,
        this.userInfo.cvu,
        this.ETAPA,
        undefined,
        archivo
      );

      this.reconsideracion.nuevaUriPu = uploadResponse.headers.location;

      this.alertService().showSuccess(this, this.$t('Consulta satisfactoria', 'Exitoso').toString());
    } catch (error) {
      this.alertService().showError(this, 'Error al consultar el PU');
    } finally {
      this.onProcess = false;
    }
  }

  public abrirNuevaUrlPu(): void {
    if (this.reconsideracion.nuevaUriPu) {
      window.open(this.reconsideracion.nuevaUriPu, '_blank', 'noopener,noreferrer');
    }
  }

  get tieneReconsideracionActiva(): boolean {
    return !!this.reconsideracion?.uri?.trim();
  }

  get onTimeReconsideracion(): boolean {
    return new Date() <= new Date(this.solucion.calendario.fechaFinReconsideracion);
  }

  /**
   * Valida que el usuario logueado sea el mismo que el de la solicitud.
   */
  get isUserOwner(): boolean {
    return this.userInfo.cvu === this.solicitud.solicitante.cvu;
  }

  get canReconsiderar(): boolean {
    return [EstadoSolicitud.EN_FIRMA, EstadoSolicitud.FORMALIZADA].includes(this.solicitud.estado) && this.isUserOwner;
  }

  public onProcess = false;

  public formatoFecha(fecha): string {
    if (fecha != null) {
      const nuevaFecha = new Date(fecha);
      return dateUtils.formatDateTimeUtcMx(nuevaFecha);
    }
    return '';
  }

  get urlArgumentosState() {
    if (!this.onTimeReconsideracion || !this.canReconsiderar || this.tieneReconsideracionActiva) {
      return null;
    }
    const value = this.reconsideracion.motivo || '';
    return value.length >= 300 && value.length <= 10000;
  }

  get urlRepositorioState() {
    const url = this.reconsideracion.urlRepositorio;
    if (!url) {
      return true;
    }
    const regex = /^https?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[^\s]*)?$/;
    return regex.test(url);
  }
}
